import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import isEqual from 'lodash.isequal'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {Icon, Link, Tooltip} from '@mdsol/onex-design'
import {diagnosticsAC} from 'redux/diagnostics/diagnostics.duck'
import './DiagnosticIdCell.scss'

interface DiagnosticIdCellProps {
  row: any
  col: any
  selectedItem: any
  diagnosticResults: any[]
}

const DiagnosticIdCell: React.FC<DiagnosticIdCellProps> = ({
  row,
  col,
  selectedItem,
  diagnosticResults,
}) => {
  const dispatch = useDispatch()
  const rowIndex = row.index
  const selected = diagnosticResults[rowIndex]
  const value = row.getValue(col.accessorKey)
  const isSame = isEqual(selectedItem, selected)
  const [copied, setCopied] = useState(false)

  const handleClick = () => {
    if (!selected) return
    dispatch(
      isSame
        ? diagnosticsAC.clearDiagnosticDetailsItem()
        : diagnosticsAC.setDiagnosticDetailsItem(selected)
    )
  }

  const handleCopy = () => {
    setCopied(true)
    setTimeout(() => setCopied(false), 1000)
  }

  return (
    <div className='cell-with-copy' style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'}}>
      <Link
        dataTestId={`diagnostic-link-${rowIndex}`}
        variant='secondary'
        onClick={handleClick}
        style={{cursor: 'pointer'}}
      >
        {value}
      </Link>

      {!copied ? (
        <div className='copy-container'>
          <CopyToClipboard text={value} onCopy={handleCopy}>
            <Icon data-testid={`copy-icon-${rowIndex}`} style={{cursor: 'pointer'}}>
              content_copy
            </Icon>
          </CopyToClipboard>
        </div>
      ) : (
        <div className='copy-container'>
          <Tooltip
            dataTestId={`copied-tooltip-${rowIndex}`}
            id={`copied-tooltip-${value}`}
            show={copied}
            placement='top-start'
            tooltipChildren='Copied!'
          >
            <Icon className='icon-copied'>check</Icon>
          </Tooltip>
        </div>
      )}
    </div>
  )
}

export default DiagnosticIdCell
